import React__default from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { filterFacetOption } from '../../utils/filter-facet-option.js';
import { orderFacetOptions } from '../../utils/order-facet-options.js';
import RefinementItem from '../RefinementItem/RefinementItem.js';

const FacetInputList = ({ items , onRefine , facet  })=>{
    const sortedItems = React__default.useMemo(()=>orderFacetOptions({
            facet,
            items
        }).filter((item)=>filterFacetOption(item, facet)
        )
    , [
        facet,
        items
    ]);
    return /*#__PURE__*/ React__default.createElement(AnimatePresence, null, /*#__PURE__*/ React__default.createElement("fieldset", null, sortedItems.map((item)=>/*#__PURE__*/ React__default.createElement(motion.div, {
            variants: facetInputItemVariants,
            key: item.label
        }, /*#__PURE__*/ React__default.createElement(RefinementItem, {
            key: item.label,
            item: item,
            facet: facet,
            onRefine: onRefine
        }))
    )));
};
var FacetInputList$1 = FacetInputList;
const facetInputItemVariants = {
    flip: {
        transition: {
            type: 'spring',
            stiffness: 500,
            damping: 800
        }
    }
};

export { FacetInputList$1 as default };
//# sourceMappingURL=FacetInputList.js.map
